import React from 'react';
import PropTypes from 'prop-types';

import './SectionOverlay.scss';

const SectionOverlay = ({ children }) => (
  <div className="section-overlay">
    <div className="section-overlay__background" />
    <div className="section-overlay__card">{children}</div>
  </div>
);

SectionOverlay.propTypes = {
  children: PropTypes.node.isRequired
};

export default SectionOverlay;
